var _rect, _rect2, _rect3, _g, _path, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConactIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 74,
    viewBox: "0 0 81 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.595215,
    width: 2.80962,
    height: 73.4653,
    fill: "#039BE5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 78.6695,
    height: 73.4653,
    fill: "#39A1F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_17",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 79,
    height: 74
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 78.6695,
    height: 73.4653,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_17)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1666 44.0001H32.8333C32.1904 44.0001 31.6666 43.4774 31.6666 42.8334V31.4584L40.2999 37.9334C40.5076 38.0897 40.7538 38.1667 40.9999 38.1667C41.2461 38.1667 41.4923 38.0897 41.6999 37.9334L50.3333 31.4584V42.8334C50.3333 43.4774 49.8094 44.0001 49.1666 44.0001ZM48.3884 30.0001L40.9999 35.5417L33.6114 30.0001H48.3884ZM49.1666 27.6667H32.8333C30.9036 27.6667 29.3333 29.2371 29.3333 31.1667V42.8334C29.3333 44.7631 30.9036 46.3334 32.8333 46.3334H49.1666C51.0963 46.3334 52.6666 44.7631 52.6666 42.8334V31.1667C52.6666 29.2371 51.0963 27.6667 49.1666 27.6667Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_17",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 27,
    width: 24,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1666 44.0001H32.8333C32.1904 44.0001 31.6666 43.4774 31.6666 42.8334V31.4584L40.2999 37.9334C40.5076 38.0897 40.7538 38.1667 40.9999 38.1667C41.2461 38.1667 41.4923 38.0897 41.6999 37.9334L50.3333 31.4584V42.8334C50.3333 43.4774 49.8094 44.0001 49.1666 44.0001ZM48.3884 30.0001L40.9999 35.5417L33.6114 30.0001H48.3884ZM49.1666 27.6667H32.8333C30.9036 27.6667 29.3333 29.2371 29.3333 31.1667V42.8334C29.3333 44.7631 30.9036 46.3334 32.8333 46.3334H49.1666C51.0963 46.3334 52.6666 44.7631 52.6666 42.8334V31.1667C52.6666 29.2371 51.0963 27.6667 49.1666 27.6667Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_17)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConactIcon);
export default __webpack_public_path__ + "static/media/conact_icon.1059e98625d24b2c38c87403931110de.svg";
export { ForwardRef as ReactComponent };